/* eslint-disable import/no-extraneous-dependencies */
import type { BrandRestaurant, WeborderingConfiguration } from 'services/brand/brand.type';
import { faker } from '@faker-js/faker/locale/fr';
import { weborderingConfigurationMock } from './mock';
import { restaurantMock } from './mockRestaurant';

export const weborderingConfigurationFixtureFactory = (
    weborderingConfigurationParams: Partial<WeborderingConfiguration> = {},
): WeborderingConfiguration => {
    return {
        ...JSON.parse(JSON.stringify(weborderingConfigurationMock)),
        ...weborderingConfigurationParams,
    };
};

export const brandRestaurantFixtureFactory = (
    params: Partial<BrandRestaurant> = {},
): BrandRestaurant => {
    return {
        ...restaurantMock,
        restaurantId: faker.datatype.number(),
        ...params,
    };
};
